<template>
    <div class="qualify-dynamic-picture">
        <template v-if="currentStep === 'building-and-shelving' || currentStep.includes('survey')">
            <div class="dynamic-picture-layer base-bw" :style="{'background-image': `url(${currentStepImage + '?grey=1'})`}">
                <!--<template v-for="floorPicture in floorPictures">
                    <img :key="floorPicture.picture" :src="require(`@/assets/img/qualify/industry/work_environment/environment/${floorPicture.environment}/floor/${floorPicture.filename}.png`)" class="reveal" :class="{'is-showed': isFloorPictureShowable(floorPicture), 'show': revealShow}" :style="currentRevealPosition" />
                </template>-->
                <img :src="currentStepImage" class="reveal" :class="{'show': revealShow}" :style="currentRevealPosition" />
            </div>
            <!--<div class="dynamic-picture-layer building" :class="environment"></div>-->
        </template>
        <template v-else>
            <div class="dynamic-picture-layer base"></div>
        </template>
    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        name: 'QualifyDynamicPicture',
        data() {
            return {
                revealPosition: null,
                revealShow: false,
                revealSizeRatio: null,
                revealLeftPositionPercentage: null,
                revealTopPositionPercentage: null,
                hideRevealTimeout: null,
                floorPictures: []
            }
        },
        computed: {
            ...mapState({
                currentStep: state => state.qualifyIndustry.currentStep,
                steps: state => state.qualifyIndustry.steps,
                environment: state => state.qualifyIndustry.environment,
                insideFloorType: state => state.qualifyIndustry.insideFloorType,
                outsideFloorType: state => state.qualifyIndustry.outsideFloorType,
            }),
            currentRevealPosition(){
                return this.revealPosition;
            },
            insideFloorTypeClass(){
                if(this.insideFloorType !== null)
                    return 'inside_'+this.insideFloorType;
            },
            outsideFloorTypeClass(){
                if(this.outsideFloorType !== null)
                    return 'outside_'+this.outsideFloorType;
            },
            filename() {
                if (this.environment === 'outside_and_inside') return 'default_default';
                else return 'default';
            },
            currentStepImage() {
                if (this.currentStep) return this.steps.find(x => x.slug === this.currentStep || x.code === this.currentStep).image;
                else return require('@/assets/img/qualify/industry/base.png');
            }
        },
        created(){
            this.generateFloorPicturesArray();
        },
        mounted(){
            window.addEventListener( 'resize', this.calcRevealPosition, false );

            this.$bus.$on('changeQualifyRevealPosition', (position) => {
                this.revealSizeRatio = position.revealSizeRatio;
                this.revealLeftPositionPercentage = position.revealLeftPositionPercentage;
                this.revealTopPositionPercentage = position.revealTopPositionPercentage;
                this.calcRevealPosition();
            });
        },
        methods: {
            calcRevealPosition(){
                if(this.revealSizeRatio && this.revealLeftPositionPercentage && this.revealTopPositionPercentage){
                    clearTimeout(this.hideRevealTimeout);
                    let reveal = document.querySelector(".reveal");
                    let revealWidth = reveal.clientWidth;
                    let revealRealSize = (revealWidth*this.revealSizeRatio);
                    this.revealPosition = `clip-path: circle(${revealRealSize}px at ${this.revealLeftPositionPercentage}% ${this.revealTopPositionPercentage}%)`
                    this.revealShow = true;
                } else {
                    this.hideRevealTimeout = setTimeout(()=> {
                        this.revealPosition = null;
                        this.revealShow = false;
                    }, 100);
                }
            },
            generateFloorPicturesArray(){
                let floorTypesInside = [
                    'default',
                    'asphalted',
                    'concreted',
                    'paved',
                    'unstabilized'
                ];

                let floorTypesOutside = [...floorTypesInside, 'asphalted_and_unstabilized'];

                floorTypesInside.forEach(floorTypeInside => this.addFloorPicturesToArray('inside', floorTypeInside))
                floorTypesOutside.forEach(floorTypeOutside => this.addFloorPicturesToArray('outside', floorTypeOutside))
                floorTypesInside.forEach(floorTypeInside => floorTypesOutside.forEach(floorTypeOutside => this.addFloorPicturesToArray('outside_and_inside', floorTypeInside+'_'+floorTypeOutside)))
            },
            addFloorPicturesToArray(environment, filename){
                this.floorPictures.push({
                    environment: environment,
                    filename: filename
                })
            },
            isFloorPictureShowable(floorPicture){
                let filename = 'default';
                let realEnvironment = (this.environment ? this.environment : 'inside');
                let realInsideFloorType = (this.insideFloorType ? this.insideFloorType : 'default');
                let realOutsideFloorType = (this.outsideFloorType ? this.outsideFloorType : 'default');

                if(this.environment === 'inside')
                    filename = realInsideFloorType;
                else if(this.environment === 'outside')
                    filename = realOutsideFloorType;
                else if(this.environment === 'outside_and_inside')
                    filename = realInsideFloorType+'_'+realOutsideFloorType;

                return (realEnvironment === floorPicture.environment && filename === floorPicture.filename)
            }
        },
    };
</script>

<style lang="scss">
    .qualify-dynamic-picture {
        position: fixed;
        width: 100vw;
        height: 80vh;
        top: 50%;
        margin-top: calc(-40vh + 100px);
        left: 50%;
        margin-left: calc(((-80vh * 1.545) /2) + 150px);
        overflow: hidden;

        @media #{$mq_phone} {
            display: none;
        }

        .dynamic-picture-layer {
            position: absolute;
            top: 0;
            left: 0;
            width: 100vw;
            height: 80vh;
            background-repeat: no-repeat;
            background-size: auto 80vh;
            transition: background-image 0.3s ease;

            &.base {
                background-image: url('~@/assets/img/qualify/industry/base.png');
            }

            &.base-bw {
                background-image: url('~@/assets/img/qualify/industry/base_bw.png');
                position: relative;

              &:before {
                content: "";
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba(255, 255, 255, 0.5);
              }
            }

            /*&.base-inside-bw {
                background-image: url('~@/assets/img/qualify/industry/base_inside_bw.png')!important;
            }

            &.base-outside-bw {
                background-image: url('~@/assets/img/qualify/industry/base_outside_bw.png')!important;
            }*/

            &.floor {
                z-index: 1;
                opacity: 0;
                transition: opacity 0.3s ease;

                &.is-showed {
                    opacity: 1;
                    transition: opacity 0s;
                }
            }

            &.building {
                z-index: 2;
                background-image: url('~@/assets/img/qualify/industry/work_environment/environment/inside/building.png');

                &.inside {
                    background-image: url('~@/assets/img/qualify/industry/work_environment/environment/inside/building.png');
                }

                &.outside {
                    background-image: url('~@/assets/img/qualify/industry/work_environment/environment/outside/building.png');
                }

                &.outside_and_inside {
                    background-image: url('~@/assets/img/qualify/industry/work_environment/environment/outside_and_inside/building.png');
                }
            }

            .reveal {
                position: absolute;
                top: 0;
                left: 0;
                z-index: 5;
                height: 80vh;
                opacity: 0;
                transition: all 0.3s ease, opacity 0s;

                &.show {
                    opacity: 1;
                    transition: all 0.3s ease;
                }
            }
        }
    }
</style>